export enum FeatureFlags {
  ReserveAccessories = 'RESERVE_ACCESSORIES',
  InstantInterview = 'INSTANT_INTERVIEW',
  BookAppointment = 'BOOK_APPOINTMENT',
}

export default FeatureFlags;
